const DEFAULT_STATUSES = ['ACTIVE'];

const parseStatuses = value => value === '' ? [] : value.split(',').filter(Boolean);

const parseTimestamp = (value, fallback) => {
    if (value === null || value === undefined || value === '') return fallback;
    const timestamp = Number(value);
    return Number.isFinite(timestamp) ? timestamp : fallback;
};

export const getInitialPublisherFilters = ({
    searchParams,
    storage,
    statusStorageKey,
    defaultFrom,
    defaultTill
}) => {
    const storedStatuses = storage.getItem(statusStorageKey);

    return {
        filterText: searchParams.get('filterText') || '',
        filterCampaignType: searchParams.get('filterCampaignType') || '',
        filterType: searchParams.get('filterType') || 'All',
        filterStatuses: searchParams.has('filterStatuses')
            ? parseStatuses(searchParams.get('filterStatuses'))
            : storedStatuses === null ? DEFAULT_STATUSES : parseStatuses(storedStatuses),
        from: parseTimestamp(
            searchParams.get('from'),
            defaultFrom
        ),
        till: parseTimestamp(
            searchParams.get('till'),
            defaultTill
        ),
        viewType: searchParams.get('viewType') || 'type'
    };
};

export const getInitialCampaignFilters = options => getInitialPublisherFilters({
    ...options,
    statusStorageKey: 'filterStatuses'
});

export const matchesCampaignSearch = (campaign, campaignType, filterText = '') => {
    const query = filterText.trim().toLowerCase();
    if (query === '') return true;

    return [
        campaign?.id,
        campaign?.type,
        campaignType?.readableType,
        campaignType?.metaData?.abbreviation
    ].some(value => typeof value === 'string' && value.toLowerCase().includes(query));
};

export const createPublisherReturnState = location => ({
    publisherReturnTo: `${location.pathname}${location.search}`
});

export const resolvePublisherReturnTo = (state, fallback) => {
    const returnTo = state?.publisherReturnTo;
    return typeof returnTo === 'string' && /^\/publisher\/(campaigns|templates|abtests)(?:\?|$)/.test(returnTo)
        ? returnTo
        : fallback;
};
